import { Checkbox, Input, Select, SelectItem } from '@heroui/react'
import { Controller } from 'react-hook-form'
import { transportOptions } from './constants'

export function SipOptions({ control, isDisabled }) {
  return (
    <div
      className={`
        grid grid-cols-1 gap-4
        md:grid-cols-2
      `}
    >
      <Controller
        name="outbound.sip_endpoint"
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            label="SIP Endpoint"
            placeholder="sip.example.com"
            variant="bordered"
            radius="sm"
            labelPlacement="outside"
            isDisabled={isDisabled}
          />
        )}
      />

      <Controller
        name="outbound.options.port"
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            type="number"
            label="Port"
            variant="bordered"
            radius="sm"
            labelPlacement="outside"
            placeholder="5060"
            value={field.value?.toString() || ''}
            onChange={e => field.onChange(Number.parseInt(e.target.value) || undefined)}
            isDisabled={isDisabled}
          />
        )}
      />

      <Controller
        name="outbound.options.sip_username"
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            label="SIP Username"
            placeholder="Optional username"
            variant="bordered"
            radius="sm"
            labelPlacement="outside"
            isDisabled={isDisabled}
          />
        )}
      />

      <Controller
        name="outbound.options.sip_password"
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            type="password"
            label="SIP Password"
            variant="bordered"
            radius="sm"
            labelPlacement="outside"
            placeholder="Optional password"
            isDisabled={isDisabled}
          />
        )}
      />

      <Controller
        name="outbound.options.transport"
        control={control}
        render={({ field }) => (
          <Select
            {...field}
            label="Transport Protocol"
            placeholder="Select transport"
            selectedKeys={field.value ? [field.value] : []}
            variant="bordered"
            radius="sm"
            labelPlacement="outside"
            onSelectionChange={(keys) => {
              const selectedKey = Array.from(keys)[0]
              field.onChange(selectedKey)
            }}
            isDisabled={isDisabled}
          >
            {transportOptions.map(option => (
              <SelectItem key={option.key} value={option.key}>
                {option.label}
              </SelectItem>
            ))}
          </Select>
        )}
      />

      <Controller
        name="outbound.options.secure_media"
        control={control}
        render={({ field }) => (
          <Checkbox
            isSelected={field.value}
            onValueChange={field.onChange}
            size="sm"
            className="mt-3"
            radius="none"
            isDisabled={isDisabled}
          >
            Secure Media (SRTP)
          </Checkbox>
        )}
      />
    </div>
  )
}
